import { all, fork, put, takeEvery, } from 'redux-saga/effects';
import * as actionTypes from 'appRedux/actions/license/licenseActionType';
import * as actionCreators from 'appRedux/actions/license';
import { API_PMS_HEADERS, API_URL_V1 } from 'constants/ApiSetting';
import { APIPostRequest } from 'util/connection';
import { ApiResponse } from 'constants/ActionTypes';

function* licenseRequestProcess() {
    const url = `${API_URL_V1}auth/rpc/subscription/get_status`;

    try {
        const response: ApiResponse = yield APIPostRequest(url, {}, API_PMS_HEADERS);

        if (response.status === 200) {
            const { result_code, result_msg, result_data } = response.data
            if(result_code === "0")
                yield put(actionCreators.licenseRequestSuccess(result_data));
            else
                yield put(actionCreators.licenseRequestFailed(result_msg || 'Failed to get license status'))
        } else {
            const { result_msg } = response.data
                yield put(actionCreators.licenseRequestFailed(result_msg || 'Failed to get license status'));
        }
    } catch (error) {
        yield put(actionCreators.licenseRequestFailed(error));
    }
}

function* watchLicenseRequest() {
    yield takeEvery(actionTypes.LICENSE_REQUEST, licenseRequestProcess);
}

export default function* licenseSaga() {
    yield all([fork(watchLicenseRequest)]);
}